export enum FontSize {
  xs = '8px',
  sm = '12px',
  md = '14px',
  lg = '16px',
  xl = '32px',
}
